"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../../type/entity");
function updateReAttemptCountForScormCard(content, reAttemptCount, state) {
    const offerType = content.offerType;
    if (offerType !== entity_1.ContentType.ASSIGNMENT_CARD) {
        return;
    }
    state.reAttemptCount = reAttemptCount;
}
exports.updateReAttemptCountForScormCard = updateReAttemptCountForScormCard;
//# sourceMappingURL=updateReAttemptCountForScormCard.js.map